import script from "./SideNavBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideNavBar.vue?vue&type=script&setup=true&lang=ts"

import "./SideNavBar.vue?vue&type=style&index=0&id=373157ef&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-373157ef"]])

export default __exports__